import React from 'react';
import classNames from 'classnames';
import { useFieldAlign } from '../useFieldAlign';
import './index.less';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function Field({
  className,
  title,
  children,
  style,
  disableAlign,
  fluid,
  center,
  noLeft,
  row,
  ellipsis
}) {
  const {
    fieldRef,
    fieldStyle
  } = useFieldAlign({
    disableAlign,
    domSelector: '.icloud-ui-card-field-title',
    calDeps: [title],
    allField: true
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('icloud-ui-card-field', {
      'grid-columns-left-auto': fluid
    }, {
      'grid-columns-left-center': center
    }, {
      'grid-columns-no-left': noLeft
    }, {
      'grid-columns-one-row': row
    }, className),
    style: style,
    children: [/*#__PURE__*/_jsxs("div", {
      ref: fieldRef,
      style: fieldStyle,
      className: "icloud-ui-card-field-title",
      children: [title, "\uFF1A"]
    }), /*#__PURE__*/_jsx("div", {
      className: classNames('icloud-ui-card-field-value', {
        'icloud-ui-card-field-value-break': !ellipsis
      }, {
        'icloud-ui-card-field-value-ellipsis': ellipsis
      }, className),
      children: children
    })]
  });
}

Field.displayName = "Field";
export default Field;
//# sourceMappingURL=es/Field/index.js.map